const initialState = {
  isFetchingAdditionalForms: false,
  isFetchingGetAllFormData: false,
  isFetchingChildCustodyRight: false,
  isFetchingCommunityProperty: false,
  isFetchingSeparateProperty: false,
  isFetchingDomesticViolence: false,
  isFetchingChildCustodyCase: false,
  isFetchingDates: false,
  isFetchingFilledPetition: false,
  isFetchingMarriedStatus: false,
  isFetchingResidence: false,
  isFetchingAddForms: false,
  isFetchingAddSppousalSupport: false,
  isFetchingAddCustody: false,
  isFetchingFormerLastName: false,
  isFetchingChildAge: false,
  isFetchingChildResidence: false,
  isUpdatingData: false,
  isFetchingCustodyTypes: false,
  isFetchingCustodySubtypes: false,
  isFetchingDPDetails: false,
  fillingOption: [],
  isFetchingOption: false, //DONE
  states: [],
  isFetchingStates: false, //DONE
  divorceLsBasis: [],
  isFetchingdivorceLsBasis: false,
  nullityBasis: [],
  getAdditionalForms: [],
  divorceId: "",
  isFetchingNullityBasis: false,
  petitionerDetails: {
    firstName: "",
    lastName: "",
    streetAddress: "",
    city: "",
    zip: "",
    state: "6",
    telephone: 0,
    email: "",
  },
  respondentDetails: {
    firstName: "",
    lastName: "",
    streetAddress: "",
    city: "",
    zip: "",
    state: "6",
    telephone: "",
    email: "",
  },
  court: {
    courtStreetAddress: " ",
    courtMailingAddress: " ",
    city: " ",
    zip: " ",
    branch: "6",
    county: "",
  },

  //Married Stepper

  isMarried: "-1",

  // Domestic Partnerhip Stepper

  domesticPartnership: {
    domesticPartnershipStatus:"-1",
    establishedInCalifornia: {
      establishedInCaliforniaStatus:"-1",
        californiaJurisdiction:{
          petitionerState:"6",
          respondentState:"6"
        }
    //}
    }
  },

  //FILED PETITION
  filedPetition: {
    dissolutionOfMarriageStatus: "-1",
    filingOption: {
      isFilingOptionStatus: "-1",
      divorce: {
        divorcedTypes: "-1",
      },
      legalSeparation: {
        legalSeparationTypes: "-1",
      },
      nulity: "-1",
    },
    yes: {
      whoFiled: {
        spouse: "-1",
        me: {
          isResponsePacket: "-1",
        },
      },
    },
  },

  //RESIDENCE
  residence: "-1",

  //DATES
  dates: {
    dateOfMarriage: " ",
    dateOfSeparation: " ",
    dateOfDP: " ",
    dateOfDPSeparation: " ",
  },

  underAge18: "-1",
  //CUSTODY RIGHTS
  custodyRights: {
    custodyRightsStatus: "-1",
  },
  //DOMESTIC VOILENCE
  domesticVoilence: {
    domesticVoilenceStatus: "-1",
  },
  //CHILD CUSTODY CASE
  childCustodyCase: {
    childCustodyCaseStatus: "-1",
  },
  //RESTORE FORMER LASTNAME
  restoreFormerLastName: {
    no: {
      restore_name_pet: "-1",
    },
    yes: {
      name_petitioner: "",
      name_response: ""
    },
  },
  //COMMUNITY PROPERTY
  communityProperty: {
    no: {
      communityPropertyStatus: "-1",
    },
    yes: {
      useLanguage: "-1",
    },
  },
  //SEPARATE PROPERTY
  separateProperty: {
    no: {
      separatePropertyStatus: "-1",
    },
    yes: {
      useLanguage: "-1",
    },
  },

  //SPOUSAL SUPPORT
  spousalSupport: {
    spousalSupportPayable: {
      spousalSupportPayableStatus: "-1",
    },
    spousalSupportTerminate: {
      spousalSupportTerminateStatus: "-1",
    },
    spousalSupportReserve: {
      spousalSupportReserveStatus: "-1",
    },
  },


  //LEGAL,PHYSICAL,CHILD CUSTODY
  childCustody: {
    additionalForm:[],
    legalCustody: "-1",
    physicalCustody: "-1",
    childVisitation: "-1",

  },
  activeStep: 0,
};

const petitionerPacketReducer = (state = initialState, action) => {
  switch (action.type) {
    //ADDITIONAL FORMS

    case "REQUEST_ADDITIONAL_FORMS":
      return { ...state, isFetchingAdditionalForms: true };
    case "SUCCESS_ADDITIONAL_FORMS":
      return {
        ...state,
        getAdditionalForms: action.payload,
        isFetchingAdditionalForms: false,
      };

    case "ERROR_ADDITIONAL_FORMS":
      return { ...state, isFetchingAdditionalForms: false };

    //ALL FORM DATA

    case "REQUEST_FORM_DATA":
      return { ...state, isFetchingGetAllFormData: true };
    case "SUCCESS_FORM_DATA":
      return {
        ...state,
        isFetchingGetAllFormData: false,
        petitionerDetails: {
          firstName: action.payload.data.petitionerDetails.firstName,
          lastName: action.payload.data.petitionerDetails.lastName,
          streetAddress: action.payload.data.petitionerDetails.streetAddress,
          city: action.payload.data.petitionerDetails.city,
          zip: action.payload.data.petitionerDetails.zip,
          state: action.payload.data.petitionerDetails.state,
          telephone: action.payload.data.petitionerDetails.telephone,
          email: action.payload.data.petitionerDetails.email,
        },
        respondentDetails: {
          firstName: action.payload.data.respondentDetails.firstName,
          lastName: action.payload.data.respondentDetails.lastName,
          streetAddress: action.payload.data.respondentDetails.streetAddress,
          city: action.payload.data.respondentDetails.city,
          zip: action.payload.data.respondentDetails.zip,
          state: action.payload.data.respondentDetails.state,
          telephone: action.payload.data.respondentDetails.telephone,
          email: action.payload.data.respondentDetails.email,
        },
        court: {
          courtStreetAddress: action.payload.data.court.courtStreetAddress,
          courtMailingAddress: action.payload.data.court.courtMailingAddress,
          city: action.payload.data.court.city,
          zip: action.payload.data.court.zip,
          branch: action.payload.data.court.branch,
          county: action.payload.data.court.county,
        },

        //Married Stepper

        isMarried: action.payload.data.isMarried,

        // Domestic Partnerhip Stepper

        domesticPartnership: {
          domesticPartnershipStatus:action.payload.data.domesticPartnership.domesticPartnershipStatus,
          establishedInCalifornia: {
            establishedInCaliforniaStatus:action.payload.data.domesticPartnership.establishedInCalifornia.establishedInCaliforniaStatus,
              californiaJurisdiction:{
                petitionerState:action.payload.data.domesticPartnership.establishedInCalifornia.californiaJurisdiction.petitionerState,
                respondentState:action.payload.data.domesticPartnership.establishedInCalifornia.californiaJurisdiction.respondentState
              }
          }
        },


        //FILED PETITION
        filedPetition: {
          dissolutionOfMarriageStatus:
            action.payload.data.filedPetition.dissolutionOfMarriageStatus,
         
          filingOption: {
            isFilingOptionStatus:
              action.payload.data.filedPetition.filingOption
                .isFilingOptionStatus,
            divorce: {
              divorcedTypes:
                action.payload.data.filedPetition.filingOption.divorce
                  .divorcedTypes,
            },
            legalSeparation: {
              legalSeparationTypes:
                action.payload.data.filedPetition.filingOption.legalSeparation
                  .legalSeparationTypes,
            },
            nulity: action.payload.data.filedPetition.filingOption.nulity,
          },
          yes: {
          
            whoFiled: {
              spouse: action.payload.data.filedPetition.yes.whoFiled.spouse,
              me: {
                isResponsePacket:
                  action.payload.data.filedPetition.yes.whoFiled.me
                    .isResponsePacket,
              },
            },
          },
        },

        //RESIDENCE
        residence: action.payload.data.residence,

        //DATES
        dates: {
          dateOfMarriage: action.payload.data.dates.dateOfMarriage,
          dateOfSeparation: action.payload.data.dates.dateOfSeparation,
          dateOfDP: action.payload.data.dates.dateOfDP,
          dateOfDPSeparation: action.payload.data.dates.dateOfDPSeparation,
        },

        
        //CHILDREN

        underAge18 : action.payload.data.underAge18,


        //CUSTODY RIGHTS
        custodyRights: {
          custodyRightsStatus:
            action.payload.data.custodyRights.custodyRightsStatus,
        },
        //DOMESTIC VOILENCE
        domesticVoilence: {
          domesticVoilenceStatus:
            action.payload.data.domesticVoilence.domesticVoilenceStatus,
        },
        //CHILD CUSTODY CASE
        childCustodyCase: {
          childCustodyCaseStatus:
            action.payload.data.childCustodyCase.childCustodyCaseStatus,
        },
        //RESTORE FORMER LASTNAME
        restoreFormerLastName: {
          no: {
            restore_name_pet:
              action.payload.data.restoreFormerLastName.no
                .restore_name_pet,
          },
          yes: {
            name_petitioner: action.payload.data.restoreFormerLastName.yes.name_petitioner,
            name_response: action.payload.data.restoreFormerLastName.yes.name_response,
          },
        },
        //COMMUNITY PROPERTY
        communityProperty: {
          no: {
            communityPropertyStatus:
              action.payload.data.communityProperty.no.communityPropertyStatus,
          },
          yes: {
            useLanguage: action.payload.data.communityProperty.yes.useLanguage,
          },
        },
        //SEPARATE PROPERTY
        separateProperty: {
          no: {
            separatePropertyStatus:
              action.payload.data.separateProperty.no.separatePropertyStatus,
          },
          yes: {
            useLanguage: action.payload.data.separateProperty.yes.useLanguage,
          },
        },

        //SPOUSAL SUPPORT
        spousalSupport: {
          spousalSupportPayable: {
            spousalSupportPayableStatus:
              action.payload.data.spousalSupport.spousalSupportPayable
                .spousalSupportPayableStatus,
          },
          spousalSupportTerminate: {
            spousalSupportTerminateStatus:
              action.payload.data.spousalSupport.spousalSupportTerminate
                .spousalSupportTerminateStatus,
          },
          spousalSupportReserve: {
            spousalSupportReserveStatus:
              action.payload.data.spousalSupport.spousalSupportReserve
                .spousalSupportReserveStatus,
          },
        },

        //LEGAL,PHYSICAL,CHILD CUSTODY
        childCustody: {
          additionalForm: action.payload.data.childCustody.additionalForm,
          legalCustody: action.payload.data.childCustody.legalCustody,
          physicalCustody: action.payload.data.childCustody.physicalCustody,
          childVisitation: action.payload.data.childCustody.childVisitation,
        },
      };

    case "ERROR_FORM_DATA":
      return { ...state, isFetchingGetAllFormData: false };

    //CHILD CUSTODY RIGHTS
    case "REQUEST_CHILD_CUSTODY_RIGHT":
      return { ...state, isFetchingChildCustodyRight: true };
    case "SUCCESS_CHILD_CUSTODY_RIGHT":
      return {
        ...state,
        isFetchingChildCustodyRight: false,
        custodyRights: {
          custodyRightsStatus: action.payload.childCustodyRight,
        },
      };

    case "ERROR_CHILD_CUSTODY_RIGHT":
      return { ...state, isFetchingChildCustodyRight: false };

    //COMMUNITY PROPERTY
    case "REQUEST_COMMUNITY_PROPERTY":
      return { ...state, isFetchingCommunityProperty: true };
    case "SUCCESS_COMMUNITY_PROPERTY":
      return {
        ...state,
        communityProperty: {
          no: {
            communityPropertyStatus: action.payload.communityProperty,
          },
          yes: {
            useLanguage: action.payload.communityLanguage,
          },
        },
        isFetchingCommunityProperty: false,
      };

    case "ERROR_COMMUNITY_PROPERTY":
      return { ...state, isFetchingCommunityProperty: false };

    //SEPARATE PROPERTY
    case "REQUEST_SEPARATE_PROPERTY":
      return { ...state, isFetchingSeparateProperty: true };
    case "SUCCESS_SEPARATE_PROPERTY":
      return {
        ...state,
        isFetchingSeparateProperty: false,
        separateProperty: {
          no: {
            separatePropertyStatus: action.payload.separateProperty,
          },
          yes: {
            useLanguage: action.payload.separateUseLanguage,
          },
        },
      };

    case "ERROR_SEPARATE_PROPERTY":
      return { ...state, isFetchingSeparateProperty: false };

    //DOMESTIC VIOLENCE
    case "REQUEST_DOMESTIC_VIOLENCE":
      return { ...state, isFetchingDomesticViolence: true };
    case "SUCCESS_DOMESTIC_VIOLENCE":
      return {
        ...state,
        isFetchingDomesticViolence: false,
        domesticVoilence: {
          domesticVoilenceStatus: action.payload.domesticViolence,
        },
      };

    case "ERROR_DOMESTIC_VIOLENCE":
      return { ...state, isFetchingDomesticViolence: false };

    //CHILD CUSTODY CASE
    case "REQUEST_CHILD_CUSTODY_CASE":
      return { ...state, isFetchingChildCustodyCase: true };
    case "SUCCESS_CHILD_CUSTODY_CASE":
      return {
        ...state,
        isFetchingChildCustodyCase: false,
        childCustodyCase: {
          childCustodyCaseStatus: action.payload.childCustody,
        },
      };

    case "ERROR_CHILD_CUSTODY_CASE":
      return { ...state, isFetchingChildCustodyCase: false };

    //DATES

    case "REQUEST_DATES":
      return { ...state, isFetchingDates: true };
    case "SUCCESS_DATES":
      return {
        ...state,
        isFetchingDates: false,
        dates: {
          dateOfMarriage: action.payload.dateofMarriage,
          dateOfSeparation: action.payload.dateofSepration,
          dateOfDP: action.payload.dateDpRegistered,
          dateOfDPSeparation: action.payload.dateDpSeprated,
        },
      };

    case "ERROR_DATES":
      return { ...state, isFetchingDates: false };

    //FilledPetition
    case "REQUEST_FILLED_PETITION":
      return { ...state, isFetchingFilledPetition: true };
    case "SUCCESS_FILLED_PETITION":
      return {
        ...state,
        isFetchingFilledPetition: false,
        filedPetition: {
          dissolutionOfMarriageStatus:
            action.payload.petitionDissolutionMarriage,
          filingOption: {
            isFilingOptionStatus: action.payload.fillingOption,
            divorce: {
              divorcedTypes: action.payload.divorceBase,
            },
            legalSeparation: {
              legalSeparationTypes: action.payload.legalSeparationBase,
            },
            nulity: action.payload.groundNullity,
          },
          yes: {
            whoFiled: {
              spouse: action.payload.whoFilled,
              me: {
                isResponsePacket: action.payload.responsePetition,
              },
            },
          },
        },
      };

    case "ERROR_FILLED_PETITION":
      return { ...state, isFetchingFilledPetition: false };

    //isMarried

    case "REQUEST_MARRIED_STATUS":
      return { ...state, isFetchingMarriedStatus: true };
    case "SUCCESS_MARRIED_STATUS":
      return {
        ...state,
        isFetchingMarriedStatus: false,
        isMarried: action.payload.isMarried,
      };

    case "ERROR_MARRIED_STATUS":
      return { ...state, isFetchingMarriedStatus: false };

    //RESIDENCE
    case "REQUEST_RESIDENCE":
      return { ...state, isFetchingResidence: true };
    case "SUCCESS_RESIDENCE":
      return {
        ...state,
        isFetchingResidence: false,
        residence: action.payload.resideCalifornia,
      };

    case "ERROR_RESIDENCE":
      return { ...state, isFetchingResidence: false };

    //ADD FORMS
    case "REQUEST_ADD_FORMS":
      return { ...state, isFetchingAddForms: true };
    case "SUCCESS_ADD_FORMS":
      return { ...state, isFetchingAddForms: false };

    case "ERROR_ADD_FORMS":
      return { ...state, isFetchingAddForms: false };

    //ADD SUPPOUSAL SUPPORT

    case "REQUEST_ADD_SUPPOUSAL":
      return { ...state, isFetchingAddSppousalSupport: true };
    case "SUCCESS_ADD_SUPPOUSAL":
      return {
        ...state,
        isFetchingAddSppousalSupport: false,
        spousalSupport: {
          spousalSupportPayable: {
            spousalSupportPayableStatus: action.payload.payableSs,
          },
          spousalSupportTerminate: {
            spousalSupportTerminateStatus: action.payload.courtAbilityAward,
          },
          spousalSupportReserve: {
            spousalSupportReserveStatus: action.payload.reserveRightsSs,
          },
        },
      };

    case "ERROR_ADD_SUPPOUSAL":
      return { ...state, isFetchingAddSppousalSupport: false };

    //ADD CUSTODIES
    case "REQUEST_ADD_CUSTODY":
      return { ...state, isFetchingAddCustody: true };
    case "SUCCESS_ADD_CUSTODY":
      return {
        ...state,
        isFetchingAddCustody: false,
        childCustody: {
          additionalForm: action.payload.additionalForm,
          legalCustody: action.payload.legalCustody,
          physicalCustody: action.payload.physicalCustody,
          childVisitation: action.payload.childVisitation,
        },
      };

    case "ERROR_ADD_CUSTODY":
      return { ...state, isFetchingAddCustody: false };

    //FORMER_LAST_NAME
    case "REQUEST_FORMER_LAST_NAME":
      return { ...state, isFetchingFormerLastName: true };
    case "SUCCESS_FORMER_LAST_NAME":
      return {
        ...state,
        isFetchingFormerLastName: false,
        restoreFormerLastName: {
          no: {
            restore_name_pet: action.payload.restoreName,
          },
          yes: {
            name_petitioner: action.payload.name_petitioner,
            name_response:state.restoreFormerLastName.yes.name_response

          },
        },
      };

    case "ERROR_FORMER_LAST_NAME":
      return { ...state, isFetchingFormerLastName: false };

    //CHILD RESIDENCE
    case "REQUEST_CHILD_RESIDENCE":
      return { ...state, isFetchingChildResidence: true };
    case "SUCCESS_CHILD_RESIDENCE":
      return {
        ...state,
        isFetchingChildResidence: false
      };

    case "ERROR_CHILD_RESIDENCE":
      return { ...state, isFetchingChildResidence: false };

    //CHILD AGE
    case "REQUEST_CHILD_AGE":
      return { ...state, isFetchingChildAge: true };
    case "SUCCESS_CHILD_AGE":
      
      return {
        ...state,
        isFetchingChildAge: false,

        underAge18 : action.payload.petitionalChildUnder18
       };

    case "ERROR_CHILD_AGE":
      return { ...state, isFetchingChildAge: false };

    //UPDATE DATA

    case "REQUEST_UPDATE_DATA":
      return { ...state, isUpdatingData: true };
    case "SUCCESS_UPDATE_DATA":
      
      return {
        ...state,
        isUpdatingData: false,
        petitionerDetails: {
          firstName: action.payload.petitionerFirstName,
          lastName: action.payload.petitionerLastName,
          streetAddress: action.payload.petitionerAddress,
          city: action.payload.petitionerCity,
          zip: action.payload.petitionerZip,
          state: action.payload.petitionerState,
          telephone: action.payload.petitionerTelephoneNo,
          email: action.payload.petitionerEmail,
        },
        respondentDetails: {
          firstName: action.payload.spouseFirstName,
          lastName: action.payload.spouseLastName,
          streetAddress: action.payload.spouseAddress,
          city: action.payload.spouseCity,
          zip: action.payload.spouseZip,
          state: action.payload.spouseState,
          telephone: action.payload.spouseTelephoneNo,
          email: action.payload.spouseEmail,
        },
        court: {
          courtStreetAddress: action.payload.courtStreetAddress,
          courtMailingAddress: action.payload.courtMailingAddress,
          city: action.payload.courtCity,
          zip: action.payload.courtZip,
          branch: action.payload.courtBranch,
          county: action.payload.county,
        },
      };

    case "ERROR_UPDATE_DATA":
      return { ...state, isUpdatingData: false };

    //CUSTODY TYPES
    case "REQUEST_CUSTODY_TYPES":
      return { ...state, isFetchingCustodyTypes: true };
    case "SUCCESS_CUSTODY_TYPES":
      return { ...state, isFetchingCustodyTypes: false };

    case "ERROR_CUSTODY_TYPES":
      return { ...state, isFetchingCustodyTypes: false };

    //CUSTODY SUBTYPES

    case "REQUEST_CUSTODY_SUBTYPES":
      return { ...state, isFetchingCustodySubtypes: true };
    case "SUCCESS_CUSTODY_SUBTYPES":
      return { ...state, isFetchingCustodySubtypes: false };

    case "ERROR_CUSTODY_SUBTYPES":
      return { ...state, isFetchingCustodySubtypes: false };

    //DOMESTIC_PARTNERSHIP

    case "REQUEST_DOMESTIC_PARTNERSHIP":
      return { ...state, isFetchingDPDetails: true };
    case "SUCCESS_DOMESTIC_PARTNERSHIP":
      return {
        ...state,
        isFetchingDPDetails: false,

        domesticPartnership: {
          domesticPartnershipStatus:action.payload.isDp,
          establishedInCalifornia: {
            establishedInCaliforniaStatus:action.payload.domesticPartnershipInCalifornia,
              californiaJurisdiction:{
                petitionerState:action.payload.petitionerLive,
                respondentState:action.payload.respondantLive
              }
          }
        }
      };

    case "ERROR_DOMESTIC_PARTNERSHIP":
      return { ...state, isFetchingDPDetails: false };
    case "REQUEST_FILLING_OPTION":
      return { ...state, isFetchingOption: true };
    case "SUCCESS_FILLING_OPTION":
      //STOP SPINNER & Show Data
      return {
        ...state,
        fillingOption: action.payload,
        isFetchingOption: false,
      };
    //Spinner and ERROR
    case "ERROR_FILLING_OPTION":
      return {
        ...state,
        isFetchingOption: false,
      };

    case "REQUEST_STATES":
      return { ...state, isFetchingStates: true };
    case "SUCCESS_STATES":
      //STOP SPINNER & Show Data
      return { ...state, states: action.payload, isFetchingStates: false };
    //Spinner and ERROR
    case "ERROR_STATES":
      return { ...state, isLogin: true, isFetchingStates: false };

    case "REQUEST_DIVORCE_LS":
      return { ...state, isFetchingdivorceLsBasis: true };
    case "SUCCESS_DIVORCE_LS":
      //STOP SPINNER & Show Data
      return {
        ...state,
        divorceLsBasis: action.payload,
        isFetchingdivorceLsBasis: false,
      };
    //Spinner and ERROR
    case "ERROR_DIVORCE_LS":
      return { ...state, isFetchingdivorceLsBasis: false };

    case "REQUEST_NULLITY":
      //STOP SPINNER & Show Data
      return { ...state, isFetchingNullityBasis: true };
    //Spinner and ERROR
    case "SUCCESS_NULLITY":
      return {
        ...state,
        nullityBasis: action.payload,
        isFetchingNullityBasis: false,
      };
    case "ERROR_NULLITY":
      //STOP SPINNER & Show Data
      return {
        ...state,
        nullityBasis: action.payload,
        isFetchingNullityBasis: false,
      };

    case "CHANGE_ACTIVE_STEP":
      return {
        ...state,
        activeStep: action.payload,
      };
    default:
      return state;
  }
};

export default petitionerPacketReducer;
